import type { LoadBalancerURL, PercentageValidation } from '@/features/fmo'

export const validatePercentages = (urls: LoadBalancerURL[]): PercentageValidation => {
  const totalPercentage = urls.reduce((sum, url) => sum + url.percentage, 0)
  
  if (totalPercentage < 100) {
    return { isValid: false, message: `Total percentage is ${totalPercentage}%. Cannot be less than 100%.` }
  }
  
  if (totalPercentage > 100) {
    return { isValid: false, message: `Total percentage is ${totalPercentage}%. Cannot exceed 100%.` }
  }
  
  return { isValid: true, message: "Valid" }
}

export const calculateTotalPercentage = (urls: LoadBalancerURL[]): number => {
  return urls.reduce((sum, url) => sum + url.percentage, 0)
}

export const isPercentageValid = (urls: LoadBalancerURL[]): boolean => {
  return calculateTotalPercentage(urls) === 100
}

export const autoConfigurePercentages = (urls: LoadBalancerURL[]): LoadBalancerURL[] => {
  if (urls.length === 0) return urls
  
  const percentagePerLink = Math.floor(100 / urls.length)
  const remainder = 100 - (percentagePerLink * urls.length)
  
  return urls.map((url, index) => ({
    ...url,
    percentage: percentagePerLink + (index < remainder ? 1 : 0)
  }))
}

export const getAutoConfigurationMessage = (urlCount: number): string => {
  switch (urlCount) {
    case 1:
      return "Auto-configured as 100%"
    case 2:
      return "Auto-configured as 50/50"
    case 3:
      return "Auto-configured as 33/33/33"
    case 4:
      return "Auto-configured as 25/25/25/25"
    default:
      return `Auto-configured as ${Math.floor(100 / urlCount)}% each (with remainder distributed)`
  }
}
